(
    function (skyward, $, undefined)
    {
        skyward.gradebookassignment = skyward.gradebook || {};

        var DEFAULT_PARENT_ASSIGNMENT_DISPLAY = true;
        var DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR = ".showParentAssignmentFS";
        var DISPLAY_PARENT_ASSIGNMENT_CB_SELECTOR = ".showParentAssignmentCheckbox";
        var SUBJECT_STANDARD_CRQE_TABLE_SELECTOR = ".subjectStandardQuickEntry .childrecordquickentrytable";

        var init = function (selector)
        {
            // SubmissionStatus codes
            const reopenedCode = "RO";
            const reopenedNewAttemptCode = "RA";
            const inProgressCode = "IP";
            const submittedCode = "SU";
            const expiredCode = "EX";

            $(selector).find(".sectionsToAssignToBrowse.handleScreenUpdates").each(function ()
            {
                var browse = $(this);
                var container = browse.parent();

                var currentAssignmentData =
                {
                    categoryID: null,
                    academicStandardIDs: null,
                    scaleMaxScore: null,
                    dueDate: null,
                    validSectionIDs: null,
                    updateRequest: null,
                    subjectIDs: null,
                    studentGroupIDs: null,
                    tierOneAcademicStandardIDs: null,
                    isOnlineAssignment: false
                };

                var setupData = function ()
                {
                    var browseBody = browse.find(".browseBody");
                    var browseBodyData = browseBody.data();
                    if (!browseBodyData)
                    {
                        return;
                    }

                    //Either we are in a workflow where we have a dueDate and CategoryID on the screen and we need to use those dynamic values
                    //or we are in the assignment details where we don't have a dueDate or categoryID on the screen and we know those values
                    if (browseBodyData.assignmentDueDate)
                    {
                        currentAssignmentData.dueDate = new Date(browseBodyData.assignmentDueDate);
                    }
                    else
                    {
                        var dueDateElement = $("[name='Assignment.DueDate']");
                        dueDateElement.on("change", updateDueDate);
                        currentAssignmentData.dueDate = skyward.controls.getValue(dueDateElement);
                    }

                    if (browseBodyData.assignmentCategoryId)
                    {
                        currentAssignmentData.categoryID = browseBodyData.assignmentCategoryId;
                    }
                    else
                    {
                        var categoryElement = $("[name='Assignment.CategoryID']");
                        categoryElement.on("change", updateCategory);
                        currentAssignmentData.categoryID = skyward.controls.getValue(categoryElement);
                    }

                    
                    var onlineAssignmentElement = $("[name='Assignment.IsOnlineAssignment']");
                    onlineAssignmentElement.on("change", updateIsOnlineAssignment);
                    currentAssignmentData.categoryID = skyward.controls.getValue(categoryElement);

                    if (container.find("input.dmsBackingData[name='StudentGroupSelectEEL']").length > 0)
                    {
                        currentAssignmentData.studentGroupIDs = getStudentGroupIDs(container.find("input.dmsBackingData[name='StudentGroupSelectEEL']"));
                    }
                };

                var updateDueDate = function ()
                {
                    currentAssignmentData.dueDate = skyward.controls.getValue($(this));
                    updateValidSections();
                };

                var updateCategory = function ()
                {
                    currentAssignmentData.categoryID = skyward.controls.getValue($(this));
                    updateValidSections();
                };

                var updateIsOnlineAssignment = function ()
                {
                    currentAssignmentData.isOnlineAssignment = skyward.controls.getValue($(this));
                    updateValidSections();
                };

                var getUpdatedSubjectIDs = function ()
                {
                    var subjectIDs = [];
                    container.find(".AssignmentSubjectIDEEL").each(function ()
                    {
                        var value = skyward.controls.getValue($(this));

                        if (value != null && value != "")
                        {
                            subjectIDs.push(value);
                        }
                    });

                    return subjectIDs;
                };

                var updateSubjects = function ()
                {
                    var subjectIDs = getUpdatedSubjectIDs();

                    if (currentAssignmentData.subjectIDs != subjectIDs)
                    {
                        currentAssignmentData.subjectIDs = subjectIDs;
                        updateValidSections();
                    }
                };

                var getUpdatedAssignmentAcademicStandardTierOneIDs = function ()
                {
                    var tierOneIDs = [];
                    container.find(".AssignmentAcademicStandardIDEELTierOne").each(function ()
                    {
                        var value = skyward.controls.getValue($(this));

                        if (value != null && value != "")
                        {
                            tierOneIDs.push(value);
                        }
                    });

                    return tierOneIDs;
                };

                var updateAssignmentAcademicStandardTierOnes = function ()
                {
                    var tierOneIDs = getUpdatedAssignmentAcademicStandardTierOneIDs();

                    if (JSON.stringify(currentAssignmentData.tierOneAcademicStandardIDs) != JSON.stringify(tierOneIDs))
                    {
                        currentAssignmentData.tierOneAcademicStandardIDs = tierOneIDs;
                        updateValidSections();
                    }
                };

                var getUpdatedAcademicStandardIDs = function ()
                {
                    var academicStandardIDs = [];
                    container.find(".AssignmentAcademicStandardIDEEL").each(function ()
                    {
                        var value = skyward.controls.getValue($(this));
                        if (value != null && value != "")
                        {
                            academicStandardIDs.push(value);
                        }
                    });

                    return academicStandardIDs;
                };

                var updateAcademicStandards = function ()
                {
                    var academicStandardIDs = getUpdatedAcademicStandardIDs();

                    if (currentAssignmentData.academicStandardIDs != academicStandardIDs)
                    {
                        currentAssignmentData.academicStandardIDs = academicStandardIDs;

                        updateValidSections();
                    }
                };

                var getStudentGroupIDs = function (input)
                {
                    var data = skyward.controls.getValue(input);

                    var studentGroupIDs = [];
                    $.each(data, function (k, v)
                    {
                        studentGroupIDs.push(k);
                    });

                    return studentGroupIDs;
                };

                var updateStudentGroups = function ()
                {
                    var studentGroupIDs = getStudentGroupIDs($(this));

                    if (currentAssignmentData.studentGroupIDs != studentGroupIDs)
                    {
                        currentAssignmentData.studentGroupIDs = studentGroupIDs;

                        updateValidSections();
                    }
                };

                var updateValidSections = function ()
                {
                    if (currentAssignmentData.updateRequest != null)
                    {
                        currentAssignmentData.updateRequest.abort();
                    }
                    currentAssignmentData.updateRequest = setValidSections();
                };

                var setValidSections = function ()
                {
                    var dueDateString = ((currentAssignmentData.dueDate.getMonth() + 1) + "/" +
                        currentAssignmentData.dueDate.getDate() + "/" +
                        currentAssignmentData.dueDate.getFullYear());

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/GetValidSectionsForClassSync/",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            dueDate: dueDateString,
                            selectedCategoryID: currentAssignmentData.categoryID,
                            selectedSubjectIDs: JSON.stringify(currentAssignmentData.subjectIDs),
                            selectedAcademicStandardIDs: JSON.stringify(currentAssignmentData.academicStandardIDs),
                            selectedStudentGroupIDs: JSON.stringify(currentAssignmentData.studentGroupIDs),
                            sectionIDs: getAllSectionIDs(browse),
                            isOnlineAssignment: currentAssignmentData.isOnlineAssignment
                        },
                        success: function (data)
                        {
                            if (data.validSectionIDs)
                            {
                                currentAssignmentData.validSectionIDs = data.validSectionIDs;
                                updateRowState();
                            }
                        }
                    });
                };

                var validDueDate = function (rowData)
                {
                    var startDate = new Date(rowData.sectionStartDate);
                    var endDate = new Date(rowData.sectionEndDate);

                    if (!currentAssignmentData.dueDate.isValidDate())
                    {
                        return false;
                    }

                    if (currentAssignmentData.dueDate < startDate || currentAssignmentData.dueDate > endDate)
                    {
                        return false;
                    }

                    return true;
                };

                var validCategory = function (row)
                {
                    var currentSectionID = getRowSectionID(row);

                    if (currentAssignmentData.validSectionIDs == null)
                    {
                        return false;
                    }

                    if (currentAssignmentData.validSectionIDs.indexOf(currentSectionID) > -1)
                    {
                        return true;
                    }

                    return false;
                };

                var updateRowState = function ()
                {
                    var hasDisabledRows = false;

                    browse.find("tr:not(.unlockedHeaderTableRow)").each(function ()
                    {
                        var row = $(this);
                        var rowData = row.data();

                        if (!$.isEmptyObject(rowData))
                        {
                            if (validDueDate(rowData) && validCategory(row))
                            {
                                skyward.editablebrowse.enableRow(row);
                            }
                            else
                            {
                                skyward.editablebrowse.disableRow(row);
                                hasDisabledRows = true;
                            }
                        }
                    });

                    var contentMessageArea = skyward.contentMessageArea.getContentMessageArea(browse);
                    if (contentMessageArea !== null)
                    {
                        if (hasDisabledRows)
                        {
                            contentMessageArea.showInformation();
                        }
                        else
                        {
                            contentMessageArea.hideInformation();
                        }
                    }
                };

                setupData();

                container.on("eelComplete", ".AssignmentSubjectIDEEL", updateSubjects);
                container.on("eelComplete", ".AssignmentAcademicStandardIDEEL:not(.AssignmentAcademicStandardIDEELTierOne)", updateAcademicStandards);
                container.on("eelComplete", ".AssignmentAcademicStandardIDEELTierOne", updateAssignmentAcademicStandardTierOnes);

                container.on("change", ".studentGroupSelectEEL .dmsBackingData", updateStudentGroups);

                container.on('childrecordquickentry-row-removed-completely', function ()
                {
                    currentAssignmentData.academicStandardIDs = getUpdatedAcademicStandardIDs();
                    currentAssignmentData.subjectIDs = getUpdatedSubjectIDs();
                    currentAssignmentData.tierOneAcademicStandardIDs = getUpdatedAssignmentAcademicStandardTierOneIDs();
                    updateValidSections();
                });

                updateAcademicStandards();
                updateSubjects();
                updateAssignmentAcademicStandardTierOnes();

            });

            var getAssignmentChildRecordQuickEntryRowCount = function (selector, isRowBeingClearedAndRemoved)
            {
                var rows = $(selector + ' ' + SUBJECT_STANDARD_CRQE_TABLE_SELECTOR + ' tbody tr:visible');
                var rowCount = Number(rows.length) - 1;
                if (isRowBeingClearedAndRemoved == true)
                {
                    //This event gets triggered before the row actually gets removed, so we should subtract 2 from the total
                    rowCount--;
                }
                return rowCount;
            };

            var SetTwoFixedDecimalsPlacesOnValue = function (value)
            {
                var valueToUse = !isNaN(value) ? value : '';
                return isNaN(parseFloat(valueToUse.toString()).toFixed(2)) ? '' : parseFloat(valueToUse.toString()).toFixed(2);
            };

            var visibleRowCount = 0;
            //Update the Max Score fields in the child record quick entry
            var updateChildren = $(selector).find('input.AssignmentChildMaxScore:visible').each(function ()
            {
                var current = $(this);
                visibleRowCount++;
                if (!current.hasClass('childrecordquickentryaddviewpart'))
                {
                    current.prop('disabled', false);
                    current.removeClass('originallyDisabled');
                    if (visibleRowCount == 1)
                    {
                        $('.disabledMaxScoreToBeEnabledIfOtherNonAddedRowsExist').each(function ()
                        {
                            var topOne = $(this);
                            topOne.prop('disabled', false);
                            topOne.removeClass('disabledMaxScoreToBeEnabledIfOtherNonAddedRowsExist');
                        });
                    }
                }
                else if (visibleRowCount > 1)
                {
                    current.prop('disabled', false);
                    current.removeClass('originallyDisabled');
                }
                else
                {
                    current.addClass('disabledMaxScoreToBeEnabledIfOtherNonAddedRowsExist');
                }
                if (current.is(':disabled'))
                {
                    current.addClass('originallyDisabled');
                }
            });

            var changeMaxScore = function (subjectStandardQuickEntry)
            {
                var container = subjectStandardQuickEntry.parents(".workflowContent, .dataObjectViewer").first();
                var assignmentMaxScore = container.find('.js-assignment-overallMaxScore');

                var defaultMaxScore = assignmentMaxScore.data().defaultMaxScore;
                var currentMaxScore = assignmentMaxScore.val();
                var assignmentMaxScoreToUse = 0;
                var sumChildAssignmentScores = 0;
                var childAssignmentCount = 0;

                // Get sum and count of child assignment scores.
                subjectStandardQuickEntry.find('input.AssignmentChildMaxScore:visible:not([style*="display: none"]):not(.doNotPost):not(.js-excludeFromMaxScoreCalc)').each(function ()
                {
                    var childScore = $(this).val();
                    if (isNaN(childScore) || childScore < 0 || childScore.length === 0)
                    {
                        childAssignmentCount++;
                        return;
                    }
                    sumChildAssignmentScores += Number(childScore);
                    childAssignmentCount++;
                });

                // Priority of score to use for parent assignment: Sum Of Child Assignments, Current Assignment Max Score, Default Assignment Score
                // There are cases where a child row is removed from the DOM before we get to the sum+count logic above leaving us with a count of 1. We still want to use this sum value in that case.
                // In other cases where the row being removed still remains in the DOM, the logic above should not be including that value in the sum.
                if (!isNaN(sumChildAssignmentScores) && childAssignmentCount > 0) 
                {
                    assignmentMaxScoreToUse = sumChildAssignmentScores;
                }
                else
                {
                    assignmentMaxScoreToUse = !isNaN(currentMaxScore) && currentMaxScore.length > 0 ? currentMaxScore
                        : !isNaN(defaultMaxScore) ? defaultMaxScore
                            : '';
                }

                skyward.controls.setValue(assignmentMaxScore, SetTwoFixedDecimalsPlacesOnValue(assignmentMaxScoreToUse));
            };

            var getSubjectStandardQuickEntryFromSelector = function (selector)
            {
                var subjectStandardQuickEntry = null;
                if ($(selector).hasClass(".subjectStandardQuickEntry"))
                {
                    subjectStandardQuickEntry = $(selector);
                }
                else
                {
                    subjectStandardQuickEntry = $(selector).find(".subjectStandardQuickEntry");
                }

                return subjectStandardQuickEntry;
            }

            var checkHideSubjectStandardMaxScore = function (quickEntry, row, isRowBeingRemoved, isRowBeingCleared)
            {
                if (quickEntry.length > 0 && getAssignmentChildRecordQuickEntryRowCount(selector, (isRowBeingRemoved && isRowBeingCleared)) <= 1)
                {
                    quickEntry.find(".maxScoreHeader").hide();
                    quickEntry.find(".AssignmentChildMaxScore").hide();
                    $(selector + ' input.js-assignment-overallMaxScore').prop('disabled', false);
                }

                if (isRowBeingRemoved && row != null)
                {
                    //Obviously don't want to do this on new rows, only on existing rows
                    if (row[0].id.startsWith('childrecordquickentrychildadd-assignment-assignmentidparent-') == false)
                    {
                        //This is so that we still know when there is dirty data on the screen, even after the row is removed
                        var hiddenID = 'RemovedRow-' + row[0].id;
                        if (quickEntry.length > 0 && row.length > 0 && $('#' + hiddenID).length == 0)
                        {
                            quickEntry.append('<hidden id="' + hiddenID + '" data-dirty="true"/>');
                        }
                    }
                    row.remove();
                }

                if (isRowBeingCleared || isRowBeingRemoved)
                {
                    quickEntry.trigger('childrecordquickentry-row-removed-completely');
                }
            };

            var showSubjectStandardMaxScore = function (quickEntry)
            {
                quickEntry.find(".AssignmentChildMaxScore").show();
                quickEntry.find(".maxScoreHeader").show();
                $(selector + ' input.js-assignment-overallMaxScore').prop('disabled', true);
            };

            var updateVisibleSubjectStandardRowCount = function (crqe)
            {
                if (crqe != null && crqe.length > 0)
                {
                    var rowCount = crqe.find("tr.childrecordquickentryrow:visible").length;
                    var container = crqe.parents(".skywardContentPanel").first();

                    var visibleSubjectStandardRowCount = container.find(".visibleSubjectStandardRowCount");
                    skyward.controls.setValue(visibleSubjectStandardRowCount, rowCount);

                    if (rowCount > 1)
                    {
                        skyward.controls.show(container.find(DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR));

                    }
                    else
                    {
                        skyward.controls.hide(container.find(DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR));
                        skyward.controls.setValue(container.find(DISPLAY_PARENT_ASSIGNMENT_CB_SELECTOR), DEFAULT_PARENT_ASSIGNMENT_DISPLAY);
                    }
                }
                else
                {
                    skyward.controls.hide($(DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR));
                    skyward.controls.setValue($(DISPLAY_PARENT_ASSIGNMENT_CB_SELECTOR), DEFAULT_PARENT_ASSIGNMENT_DISPLAY);
                }
            }

            var setUpAssignmentWorkflowEvents = async function ()
            {
                //Handle Subject IDs on EEL
                $(selector + ' div.codeEEL.AssignmentSubjectIDEEL, ' + selector + ' div.codeEEL.AssignmentAcademicStandardIDEELTierOne').on('eelComplete', async function (event)
                {
                    var target = $(event.target);
                    var action = 'HandleSubjectIDChangeWorkflow';
                    var data = (await skyward.ajax.getAllInputElements($('.workflowContent'))) || [];
                    if (data.IsCustomName === undefined)
                    {
                        action = 'HandleSubjectIDChange';
                        data = await skyward.ajax.getAllInputElements($('.contentArea'));
                    }
                    data.ChildSelectorLevel = target[0].id.split("-").slice(-1)[0];

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (returnData)
                            {
                                var parentSelector = "SubjectsAndStandardsQuickEntryFS";
                                var parent = target.parents('#' + parentSelector);
                                parentSelector = parent.length > 0 ? parentSelector : 'editAssignment_' + parentSelector;
                                parent = parent.length > 0 ? parent : target.parents('#' + parentSelector);
                                skyward.ajax.handleResponse(returnData, parentSelector, false, parent);
                            }
                        });
                });

                
                //Handle Standard IDs on EEL
                $(selector + ' div.codeEEL.AssignmentAcademicStandardIDEEL').on('eelComplete', async function (event)
                {
                    var target = $(event.target);
                    var action = 'HandleAcademicStandardIDChangeWorkflow';
                    var data = {};
                    if ($(".workflowContent").length > 0)
                    {
                        data = await skyward.ajax.getAllInputElements($('.workflowContent'));
                        isWorkflow = true;
                    }
                    else
                    {
                        data = await skyward.ajax.getAllInputElements($('.contentArea'));
                        action = 'HandleAcademicStandardIDChange';
                    }
                    data.ChildSelectorLevel = target[0].id.split("-").slice(-1)[0];
                    data.hasMultipleStandardsOnScreen = target.parents("tr").siblings(".childrecordquickentryrow:visible").length > 0;
                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (returnData)
                            {
                                var parentSelector = "SubjectsAndStandardsQuickEntryFS";
                                var parent = target.parents('#' + parentSelector);
                                parentSelector = parent.length > 0 ? parentSelector : 'editAssignment_' + parentSelector;
                                parent = parent.length > 0 ? parent : target.parents('#' + parentSelector);
                                skyward.ajax.handleResponse(returnData, parentSelector, false, parent);
                            }
                        });
                });

                checkHideSubjectStandardMaxScore(getSubjectStandardQuickEntryFromSelector(selector), null, false, false);

                var getSelectorElementToUse = function (selectorToUse)
                {
                    var selectorElement = $(selectorToUse).closest(SUBJECT_STANDARD_CRQE_TABLE_SELECTOR);

                    if (selectorElement.length <= 0)
                    {
                        selectorElement = $(selectorToUse + ' ' + SUBJECT_STANDARD_CRQE_TABLE_SELECTOR);
                    }

                    return selectorElement;
                };

                var setUpAcademicStandardEvents = function (selectorToUse)
                {
                    var selectorElement = getSelectorElementToUse(selectorToUse);

                    //Need to override the events for my codeEELs so that it will perform my event first
                    selectorElement.find('div.codeEEL.AssignmentAcademicStandardIDEEL').off('click keydown keyup input');

                    //Handle Standard IDs on EEL Search (for details)
                    //Remove events from specific elements here too, because this is more specific
                    selectorElement.find('div.codeEEL.AssignmentAcademicStandardIDEEL a').off('click').on('click', function (event)
                    {
                        showEELPopup(event);
                    });

                    selectorElement.find('div.codeEEL.AssignmentAcademicStandardIDEEL').on('keydown', function (event)
                    {
                        if (event.keyCode == 13 || event.keyCode == 40)//enter or down arrow
                        {
                            showEELPopup(event);
                        }
                    });

                    selectorElement.find('div.codeEEL.AssignmentAcademicStandardIDEEL').on(skyward.global.isAndroidApp ? 'keyup' : 'input', function (event)
                    {
                        showEELPopup(event);
                    });

                    var showEELPopup = function (event)
                    {
                        var standardEELPopup = $('div[id^="AcademicStandardID-"][id$="_description_popup"], div[id^="WorkflowAcademicStandardID-"][id$="_description_popup"]');
                        if (standardEELPopup.length <= 0)
                        {
                            performHandleStandardIDsOnEELSearch(event);
                        }
                    };
                };

                setUpAcademicStandardEvents(selector);

                var performHandleStandardIDsOnEELSearch = async function (event)
                {
                    var target = $(event.target);
                    if (!target.hasClass('codeEELDescription'))
                    {
                        target = target.parents('div.AssignmentAcademicStandardIDEEL').find('input.eELInputContainer__textBox');
                    }

                    event.preventDefault();
                    event.stopPropagation();

                    var isWorkflowAlias = $('.workflowContent').length > 0;

                    var data = isWorkflowAlias == true ? await skyward.ajax.getAllInputElements($('.workflowContent')) : await skyward.ajax.getAllInputElements($('.contentArea'));
                    data.ChildSelectorLevel = target.parents('div.codeEEL.AssignmentAcademicStandardIDEEL, div.codeEEL.AssignmentAcademicStandardIDEELTierOne')[0].id.split("-").slice(-1)[0];
                    data.seekText = skyward.controls.getValue(target);

                    var updateAcademicStandardIDs = $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Assignment/HandleSubjectIDChange" + (isWorkflowAlias == true ? "Workflow" : ""),
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (returnData)
                            {
                                var parentSelector = "SubjectsAndStandardsQuickEntryFS";
                                var parent = target.parents('#' + parentSelector);
                                parentSelector = parent.length > 0 ? parentSelector : 'editAssignment_' + parentSelector;
                                parent = parent.length > 0 ? parent : target.parents('#' + parentSelector);
                                skyward.ajax.handleResponse(returnData, parentSelector, false, parent);
                            }
                        });

                    $.when(updateAcademicStandardIDs).done(function ()
                    {
                        var eelSelector = 'div.codeEEL.AssignmentAcademicStandardIDEEL';
                        var parent = target.parents(eelSelector);

                        //Turn off all of our custom events on the code eel/button so that they get reset when we register the code eel
                        getSelectorElementToUse(eelSelector).find(eelSelector + ', ' + eelSelector + ' a').off('click keydown keyup input');
                        skyward.codeeel.registerCodeEEL(parent);

                        //Check if the seek text is equal to the original text.  If so, the code eel's input event won't work for us.
                        if (event.type == 'click' || data.seekText == target.data('original-value'))
                        {
                            parent.find('a').click();
                        }
                        else
                        {
                            //Trigger the input event to cause the code eel to search for the entered value
                            //TODO: Triggering events manually is not optimal, we should try and think of a better way to accomplish this
                            target.trigger('input');
                        }

                        //Reset our custom input events on the code eel
                        setUpAcademicStandardEvents(eelSelector);
                    });
                };

                //Add button clicked
                $(selector).find('.subjectStandardQuickEntry div.childrecordquickentryadddiv').on('childrecordquickentry-row-added', 'a.save.js-childrecordquickentry', function ()
                {
                    var rowCount = getAssignmentChildRecordQuickEntryRowCount(selector, false);
                    if (rowCount > 1)
                    {
                        var assignmentMaxScore = $(selector + ' input.js-assignment-overallMaxScore');
                        assignmentMaxScore.prop('disabled', true);

                        showSubjectStandardMaxScore($(this).parents(".subjectStandardQuickEntry"));
                    }

                    if (rowCount == 2)
                    {
                        var assignmentMaxScore = $('input.js-assignment-overallMaxScore');
                        var firstRowMaxScore = $('.AssignmentChildMaxScore:visible:first');
                        var firstRowStandard = $('.AssignmentAcademicStandardIDEEL:visible:first');
                        var valueToAssign = parseFloat(assignmentMaxScore.val());
                        skyward.controls.setValue(firstRowMaxScore, SetTwoFixedDecimalsPlacesOnValue(valueToAssign), true);
                        if (firstRowStandard.length > 0)
                        {
                            firstRowStandard.trigger('eelComplete');
                        }
                    }

                    updateVisibleSubjectStandardRowCount($(this).parents(".subjectStandardQuickEntry"));
                });

                //Clear button clicked
                $(selector).find('.subjectStandardQuickEntry tr.js-childrecordquickentrychild .childrecordquickentryclearbuttoncell, .subjectStandardQuickEntry tr.js-childrecordquickentrychildadd .childrecordquickentryclearbuttoncell').on('childrecordquickentry-row-cleared', function (event, clearedRow, isRowBeingRemoved)
                {
                    if (getAssignmentChildRecordQuickEntryRowCount(selector, isRowBeingRemoved) <= 1)
                    {
                        var assignmentMaxScore = $(selector + ' input.js-assignment-overallMaxScore:not(".originallyDisabled")');
                        assignmentMaxScore.prop('disabled', false);
                    }

                    //This little bit of jank is allowing us to get the correct max score after clearing the row since it hasn't been hidden in the DOM at this point.
                    var childAssignmentScoreInput = clearedRow.find('input.AssignmentChildMaxScore');
                    childAssignmentScoreInput.addClass('js-excludeFromMaxScoreCalc');
                    changeMaxScore(subjectStandardQuickEntry);
                    childAssignmentScoreInput.removeClass('js-excludeFromMaxScoreCalc');

                    checkHideSubjectStandardMaxScore($(this).parents(".subjectStandardQuickEntry"), clearedRow, isRowBeingRemoved, true);
                    updateVisibleSubjectStandardRowCount($(selector + " .subjectStandardQuickEntry"));
                });

                //Remove button clicked
                $(selector).find('.subjectStandardQuickEntry tr.js-childrecordquickentrychild .js-childRecordQuickEntryClearRow').on('childrecordquickentry-row-removed', function (event)
                {
                    var targetRow = $(this).parents("tr").first();
                    var subjectStandardQuickEntry = targetRow.parents(".subjectStandardQuickEntry");
                    targetRow.remove();
                    changeMaxScore(subjectStandardQuickEntry);
                    checkHideSubjectStandardMaxScore(subjectStandardQuickEntry, targetRow, true, false);
                    updateVisibleSubjectStandardRowCount(subjectStandardQuickEntry);
                });

                $(selector).find('input.AssignmentChildMaxScore:not(.doNotPost)').on('change', function ()
                {
                    var childMaxScore = $(this);
                    var subjectStandardQuickEntry = childMaxScore.parents(".subjectStandardQuickEntry").first();
                    changeMaxScore(subjectStandardQuickEntry);
                    event.stopPropagation();
                    event.preventDefault();
                });

                //Handle Change Event for Overall Assignment Max Score
                $(selector).find('input.js-assignment-overallMaxScore').on('change', function (event)
                {
                    var amountToAssign = 0;
                    var assignmentMaxScoreValue = $(event.target).val();
                    if (!isNaN(assignmentMaxScoreValue) && assignmentMaxScoreValue > 0)
                    {
                        amountToAssign = assignmentMaxScoreValue;
                    }
                    if (getAssignmentChildRecordQuickEntryRowCount(selector, false) <= 1)
                    {
                        $(selector).find('input.AssignmentChildMaxScore:not(.doNotPost)').each(function ()
                        {
                            var current = $(this);
                            skyward.controls.setValue(current, SetTwoFixedDecimalsPlacesOnValue(amountToAssign), true);
                        });
                    }
                });

                $.when(updateChildren).done(function ()
                {
                    if (visibleRowCount > 1)
                    {
                        $('input.js-assignment-overallMaxScore').prop('disabled', true);
                    }
                });

                $(selector).find('#AssignmentIsOnlineAssignment, input.isOnlineAssignment').each(function ()
                {
                    var current = $(this);
                    if (current.is(':disabled'))
                    {
                        current.addClass('originallyDisabled');
                    }
                });
            };

            setUpAssignmentWorkflowEvents();

            if ($(selector).find(".assignmentContent").length > 0)
            {
                var subjectStandardQuickEntry;

                if ($(selector).parents(".subjectStandardQuickEntry").length > 0)
                {
                    subjectStandardQuickEntry = $(selector).parents(".subjectStandardQuickEntry").first();
                }
                else
                {
                    subjectStandardQuickEntry = $(selector).find(".subjectStandardQuickEntry");
                }
                updateVisibleSubjectStandardRowCount(subjectStandardQuickEntry, selector);
            }

            $(selector).find('.gradebookSyncedObjectCustomDelete').click(function ()
            {
                var deleteButton = $(this);
                var deleteButtonData = deleteButton.data();
                var urlReferrer = deleteButtonData.urlReferrer;
                var linkedObjectsToDeleteBrowse = $('#' + deleteButtonData.browseName);
                var browseData = linkedObjectsToDeleteBrowse.data();
                var editableBrowseData = browseData ? browseData.editablebrowsedata : [];
                var idsToDelete = [];
                for (var i = 0; i < editableBrowseData.length; i++)
                {
                    var data = editableBrowseData[i];

                    if (data.value == true)
                    {
                        idsToDelete.push(data.datadictionary[deleteButtonData.foreignKeyField]);
                    }
                }

                var data =
                    {
                        IdsToDelete: JSON.stringify(idsToDelete),
                        deleteForAllSynced: deleteButtonData.deleteForAllSynced,
                        UrlReferrer: urlReferrer
                    };
                skyward.window.loadContent("full", "Gradebook", deleteButtonData.deleteController, "CompleteDelete", deleteButton.data().primaryKeyValue, data);
            });

            $(selector).find('#editAssignment_AssignedDate').on('change', function ()
            {
                updateDueDate($(this), false);
            });
            $(selector).find("[name='Assignment.AssignedDate']").on('change', function ()
            {
                updateDueDate($(this), true);
            });
            $(selector).find(".assignmentDetails.isOnlineAssignment").on('change', function ()
            {
                updateOnlineAssignments(selector, $(this));
            });

            $(selector).find("#editStudentAssignment").on("change", ".onlineAssignmentManualScore", function ()
            {
                var textbox = $(this);
                if (!textbox.is(':disabled') && !textbox.is('[readonly]'))
                {
                    var assignmentQuestionID = textbox.data().assignmentQuestionId;

                    var dov = textbox.parents(".dataObjectViewer");
                    var scoreField = dov.find(".onlineAssignmentTotalScore");
                    if (textbox.data().organizerType == "AS")
                    {
                        //Need to sum up each individual onlineAssignmentSubTotalScore first based on onlineAssignmentManualScore_academicStandardID
                        //then we can sum the subtotatls

                        updateQuestionContainerSubtotal(textbox);

                        //if this question exists elsewhere, update that one as well.
                        dov.find(".assignmentQuestion_" + assignmentQuestionID).each(function ()
                        {
                            var duplicateQuestion = $(this);

                            var textBoxValue = skyward.controls.getValue(textbox);
                            if (textBoxValue)
                            {
                                textBoxValue = parseFloat(textBoxValue).toFixed(2);
                            }
                            skyward.controls.setValue(duplicateQuestion, textBoxValue, true);
                            updateQuestionContainerSubtotal(duplicateQuestion);
                        });


                        updateAssignmentTotal(scoreField);
                    }
                    else if ((!scoreField.is(':disabled') && !scoreField.is('[readonly]')) ||
                             (scoreField.data().isParentAssignment.toString().toLowerCase() == "true" && scoreField.data().persistReadOnly.toString().toLowerCase() == "false"))
                    {
                        var total = null;
                        dov.find(".onlineAssignmentManualScore:visible").each(function ()
                        {
                            var innerTextbox = $(this);
                            var value = skyward.controls.getValue(innerTextbox);
                            if (value)
                            {
                                if (total == null)
                                {
                                    total = 0.00;
                                }
                                var multiplier = 1;

                                if (innerTextbox.data().multiplier != null)
                                {
                                    multiplier = parseFloat(innerTextbox.data().multiplier);
                                }
                                total += parseFloat(value) * multiplier;
                            }
                        });

                        if (total)
                        {
                            total = total.toFixed(2);
                        }
                        skyward.controls.setValue(scoreField, total);
                    }
                }
            });

            $(selector).find(".onlineAssignmentSubTotalScore").on("change", function ()
            {
                updateAssignmentTotal($(this));
            });

            var updateQuestionContainerSubtotal = function (textbox)
            {
                var subtotal = null;
                var dov = textbox.parents(".dataObjectViewer");
                dov.find(".onlineAssignmentManualScore." + textbox.data().identifierSuffix + ":visible").each(function ()
                {
                    var value = skyward.controls.getValue($(this));
                    if (value)
                    {
                        if (subtotal == null)
                        {
                            subtotal = 0.00;
                        }
                        subtotal += parseFloat(value);
                    }
                });
                if (subtotal)
                {
                    subtotal = subtotal.toFixed(2);
                }

                var standardScoreField = dov.find("#ByAcademicStandard_AcademicStandardScore_" + textbox.data().identifierSuffix + ".onlineAssignmentSubTotalScore");
                skyward.controls.setValue(standardScoreField, subtotal);
            };

            var updateAssignmentTotal = function (textbox)
            {
                var dov = textbox.parents(".dataObjectViewer");
                var scoreField = dov.find(".onlineAssignmentTotalScore");

                var total = 0.00;
                dov.find(".onlineAssignmentSubTotalScore").each(function () 
                {
                    var value = skyward.controls.getValue($(this));
                    if (value)
                    {
                        total += parseFloat(value);
                    }
                });

                total = total.toFixed(2);
                skyward.controls.setValue(scoreField, total);

            };

            $(selector).find('.contentArea').on('fileAdded', function (event, data)
            {
                updateCurrentAddedMedia($(this), data);
            });

            var updateMassCopyAssignmentsBrowseAjaxRequest = null;

            $(selector).find('.massCopyAssignmentsSectionIDs').on('change', function (event)
            {
                if (updateMassCopyAssignmentsBrowseAjaxRequest)
                {
                    updateMassCopyAssignmentsBrowseAjaxRequest.abort();
                }

                var actionSuffix = $("#MassCopyAssignmentsIsTeacherAccess").val() === "True" ? "" : "Admin";

                updateMassCopyAssignmentsBrowseAjaxRequest = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Assignment/UpdateMassCopyAssignmentsBrowse" + actionSuffix,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        sectionID: $(this).val()
                    },
                    activityIndicator: { silent: true },
                    success: function (viewParts)
                    {
                        var browseParentDiv = $('#SourceAssignmentsMassCopy');
                        browseParentDiv.empty();
                        var browseID = browseParentDiv.attr('id');

                        browseParentDiv.append(viewParts);
                        skyward.window.notifyDOMLoad('#' + browseID);
                        updateMassCopyAssignmentsBrowseAjaxRequest = null;
                    }
                });
            });

            var updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest = null;

            $(selector).find('.massCopyAssignmentsFromPreviousClassSectionIDs').on('change', function (event)
            {
                if (updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest)
                {
                    updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest.abort();
                }

                updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Assignment/UpdateMassCopyAssignmentsFromPreviousClassBrowse",
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        sectionID: $(this).val()
                    },
                    activityIndicator: { silent: true },
                    success: function (viewParts)
                    {
                        var browseParentDiv = $('#SourceAssignmentsMassCopy');
                        browseParentDiv.empty();
                        var browseID = browseParentDiv.attr('id');

                        browseParentDiv.append(viewParts);
                        skyward.window.notifyDOMLoad('#' + browseID);
                        updateMassCopyAssignmentsFromPreviousClassBrowseAjaxRequest = null;
                    }
                });
            });

            $(selector).find('#SelectAssignmentsToAdd, #SelectStudentGroupAssignmentsToRemove').on('change', '.syncAssignmentCheckBox ', function (event)
            {
                var checkbox = $(this);
                var data = checkbox.data();

                var isSynced = data.issynced.toString().toLowerCase();

                if (isSynced == "false" && checkbox.is(":checked"))
                {
                    skyward.controls.setValue(checkbox, false);
                    setTimeout(function ()
                    {
                        skyward.controls.disable(checkbox);
                    }, 20);
                }
            });

            var printStudentAssignment = function ()
            {
                var element = $(this);
                var data = element.data();
                var action = "PrintStudentAssignmentOptionsPopup";

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data:
                        {
                            assignmentID: data.assignmentid,
                            staffID: data.staffID
                        }
                    });
                };

                var createButton = { id: 'studentAssignmentPrintoutPopupCreate', text: "Print Preview", click: function () { studentAssignmentPrintoutPopupCreate(dialog); }, icon: "View" };
                var closeButton = { id: 'studentAssignmentPrintoutPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Print Student Assignment', buildPopup, [createButton, closeButton]);
            };

            var studentAssignmentPrintoutPopupCreate = function (dialog)
            {
                var parameters = studentAssignmentPrintoutPopupParameters(dialog);
                var buildHTML = studentAssignmentPrintoutPopupBuild('BuildStudentAssignmentPrintout', parameters);

                var printButton = { id: 'studentAssignmentPrintoutPopupPrint', text: "Print", click: function () { studentAssignmentAnswerKeySharedPrintoutPopupPrint('Print Student Assignment', 'BuildStudentAssignmentPrintoutPdf', parameters); }, icon: "PrintAvailable" };
                var closeButton = { id: 'studentAssignmentPrintoutPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Student Assignment', buildHTML, [printButton, closeButton], { width: "75%", additionalClasses: "studentAssignmentModal" });
                gridPopup.content.addClass('studentAssignmentPrintoutModalContent');
            };

            var studentAssignmentPrintoutPopupParameters = function (dialog)
            {
                var printClassDetails = dialog.content.find('.printClassOptionHeader').is(':checked');
                var leaveRoomForStudentName = dialog.content.find('.leaveRoomForStudentName').is(':checked');

                var data = $('.printStudentAssignmentPopupContent').data();
                var sectionID = data.sectionid.toString();
                var assignmentID = data.assignmentid.toString();

                var parameters =
                {
                    printClassDetails: printClassDetails,
                    leaveRoomForStudentName: leaveRoomForStudentName,
                    assignmentID: assignmentID,
                    sectionID: sectionID
                };
                return parameters;
            };

            var studentAssignmentPrintoutPopupBuild = function (action, data)
            {
                var buildHTML = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: data
                    });
                };
                return buildHTML;
            };

            var printAnswerKey = function ()
            {
                var element = $(this);
                var data = element.data();
                var action = "PrintAnswerKeyOptionsPopup";

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data:
                        {
                            assignmentID: data.assignmentid,
                            staffID: data.staffID
                        }
                    });
                };

                var createButton = { id: 'answerKeyPrintoutPopupCreate', text: "Print Preview", click: function () { answerKeyPrintoutPopupCreate(dialog); }, icon: "View" };
                var closeButton = { id: 'answerKeyPrintoutPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Print Answer Key', buildPopup, [createButton, closeButton]);
            };

            skyward.gradebookassignment.updateSubmissionStatuses = function (value)
            {
                var comboBoxes = $(".updatedSubmissionStatusComboBoxRow");

                comboBoxes.each(function ()
                {
                    var comboBox = $(this);
                    if (comboBox.find('option[value="' + value + '"]').length > 0)
                    {
                        skyward.controls.setValue(comboBox, value);
                    }
                });
            };

            skyward.gradebookassignment.updateSubmissionStatusRow = function (control)
            {
                var comboBox = $(control);
                var parentBrowse = comboBox.parents("#MassUpdateStudentAssignmentSubmissionStatusEntry");
                var checkboxFieldSet = parentBrowse.siblings("#fsClearQuestionScores");
                var studentAssignmentID = comboBox.data('student-assignment-id');

                var showClearScoreCheckbox = false;

                var newStatus = skyward.controls.getValue(comboBox);
                var additionalMinutesInput = parentBrowse.find('#AdditionalMinutes-' + studentAssignmentID);
                updateAdditionalMinutesTextBox(additionalMinutesInput, newStatus);

                var originalValue = comboBox.data('original-value');
                if (originalValue !== newStatus &&
                    (newStatus === reopenedCode ||
                        newStatus === reopenedNewAttemptCode ||
                        newStatus === inProgressCode))
                {
                    showClearScoreCheckbox = true;
                }

                skyward.controls.toggleVisible(checkboxFieldSet, showClearScoreCheckbox, true);
            };

            function updateSingleStudentAssignmentComboBoxInit()
            {
                var statusComboBox = $(this);
                var parent = statusComboBox.parents('.workflowContent').first();
                var data = parent.find('.js-CurrentStatusComboBox').first().data();
                var additionalMinutesTextBox = parent.find('.js-AdditionalMinutesTextBox').first();

                if (data['isTimed'] === "True")
                {
                    var currentStatusCode = data['currentStatusCode'];
                    skyward.controls.setValue(statusComboBox, currentStatusCode);
                    setAdditionalMinutesTextBoxReadOnly(additionalMinutesTextBox, currentStatusCode);
                }

                statusComboBox.on('change', updateSingleSubmissionStatus);
            }

            function updateSingleSubmissionStatus()
            {
                var statusComboBox = $(this);
                var parent = statusComboBox.parents('.workflowContent').first();
                var additionalMinutesTextBox = parent.find('.js-AdditionalMinutesTextBox').first();

                if (additionalMinutesTextBox.length > 0)
                {
                    var newStatus = skyward.controls.getValue(statusComboBox);
                    updateAdditionalMinutesTextBox(additionalMinutesTextBox, newStatus);
                }
            }

            function updateAdditionalMinutesTextBox(additionalMinutesTextBox, newStatus)
            {
                setAdditionalMinutesTextBoxReadOnly(additionalMinutesTextBox, newStatus);
                setAdditionalMinutesTextBoxValue(additionalMinutesTextBox, newStatus);
            }

            function setAdditionalMinutesTextBoxReadOnly(additionalMinutesTextBox, status)
            {
                if (status === submittedCode ||
                    status === expiredCode)
                {
                    additionalMinutesTextBox.prop('readonly', true);
                    skyward.controls.setValue(additionalMinutesTextBox, '');
                    return;
                }
                else
                {
                    additionalMinutesTextBox.prop('readonly', false);
                }
            }

            function setAdditionalMinutesTextBoxValue(additionalMinutesTextBox, newStatus)
            {
                var currentAdditionalMinutesVal = $.trim(skyward.controls.getValue(additionalMinutesTextBox));

                if (currentAdditionalMinutesVal == '' &&
                    (newStatus === reopenedCode || newStatus === reopenedNewAttemptCode)) {
                    defaultMinutesAllowed = additionalMinutesTextBox.data('default-minutes');
                    skyward.controls.setValue(additionalMinutesTextBox, defaultMinutesAllowed);
                }
            }

            function clearAdditionalMinutesColumn() {
                var columns = $(".additionalMinutesTextbox");

                $.each(columns, function () {
                    skyward.controls.setValue($(this), '');
                });
            };

            function massUpdateMinutesAllowed() {
                var button = $(this);
                var columns = $(".additionalMinutesTextbox:not([readonly])");
                var value = skyward.controls.getValue(button.siblings("#minutesAllowedHeaderTextBox"));

                $.each(columns, function () {
                    var additionalMinutesTextBox = $(this);

                    if (!additionalMinutesTextBox.is(":disabled")) {
                        skyward.controls.setValue(additionalMinutesTextBox, value);
                    }
                });
            };

            var answerKeyPrintoutPopupCreate = function (dialog)
            {
                var parameters = answerKeyPrintoutPopupParameters(dialog);
                var buildHTML = answerKeyPrintoutPopupBuild('BuildAnswerKeyPrintout', parameters);

                var printButton = { id: 'answerKeyPrintoutPopupPrint', text: "Print", click: function () { studentAssignmentAnswerKeySharedPrintoutPopupPrint('Print Answer Key', 'BuildAnswerKeyPrintoutPdf', parameters); }, icon: "PrintAvailable" };
                var closeButton = { id: 'answerKeyPrintoutPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Answer Key', buildHTML, [printButton, closeButton], { width: "75%", additionalClasses: "answerKeyModal" });
                gridPopup.content.addClass('answerKeyPrintoutModalContent');
            };

            var answerKeyPrintoutPopupParameters = function (dialog)
            {
                var dialogOptionValues = getPrintDialogOptionValues(dialog);

                var data = $('.printStudentAssignmentPopupContent').data();
                var sectionID = data.sectionid.toString();
                var assignmentID = data.assignmentid.toString();
                var data =
                {
                    printClassDetails: dialogOptionValues.printClassDetails,
                    showQuestionInstructions: dialogOptionValues.showQuestionInstructions,
                    showQuestionImages: dialogOptionValues.showQuestionImages,
                    leaveRoomForStudentName: dialogOptionValues.leaveRoomForStudentName,
                    assignmentID: assignmentID,
                    sectionID: sectionID
                };
                return data;
            };

            var answerKeyPrintoutPopupBuild = function (action, data)
            {

                var buildHTML = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: data
                    });
                };
                return buildHTML;
            };

            var printOnlineStudentAssignment = function () {
                var element = $(this);
                var data = element.data();
                var popupAction = data.popupaction;

                var popupData =
                {
                     assignmentID: data.assignmentid,
                     isMultiPrint: data.ismultiprint
                }

                if (data.studentsectionid != null) {
                    popupData.studentSectionID = data.studentsectionid
                }

                var buildPopup = function () {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + popupAction,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: popupData
                    });
                };

                var createButton = { id: 'onlineStudentAssignmentPrintoutPopupCreate', text: "Print Preview", click: function () { studentOnlineAssignmentPrintoutPopupCreate(dialog); }, icon: "View" };
                var closeButton = { id: 'onlineAssignmentPrintoutPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var popupHeader = 'Print Student Assignment';

                if (popupData.isMultiPrint == true)
                {
                    popupHeader += 's';
                }

                var dialog = skyward.modalLayer.showDialog(popupHeader, buildPopup, [createButton, closeButton]);
            };

            var onlineStudentAssignmentPrintoutPopupParameters = function (dialog) {
                var dialogOptionValues = getPrintDialogOptionValues(dialog);

                var data = $('.printStudentAssignmentPopupContent').data();
                var sectionID = data.sectionid.toString();
                var assignmentID = data.assignmentid.toString();
                var isMultiPrint = data.ismultiprint.toString();

                var parameters =
                {
                    printClassDetails: dialogOptionValues.printClassDetails,
                    showQuestionInstructions: dialogOptionValues.showQuestionInstructions,
                    showQuestionImages: dialogOptionValues.showQuestionImages,
                    leaveRoomForStudentName: dialogOptionValues.leaveRoomForStudentName,
                    notStarted: dialogOptionValues.notStarted,
                    inProgress: dialogOptionValues.inProgress,
                    reopened: dialogOptionValues.reopened,
                    reopenedAsNewAttempt: dialogOptionValues.reopenedAsNewAttempt,
                    expired: dialogOptionValues.expired,
                    submitted: dialogOptionValues.submitted,
                    scored: dialogOptionValues.scored,
                    studentNameDisplayTypeCode: dialogOptionValues.studentNameDisplayTypeCode,
                    assignmentID: assignmentID,
                    sectionID: sectionID,
                    isMultiPrint: isMultiPrint,
                    isMultiPrint: isMultiPrint
                };

                if (data.studentsectionid != null) {
                    parameters.studentSectionID = data.studentsectionid.toString();
                }

                selectedStudentsEEL = dialog.content.find('#ContingentStudentAssignmentsEEL')[0];
                if (selectedStudentsEEL != null) {
                    parameters.selectedStudents = selectedStudentsEEL.value
                }

                return parameters;
            };

            var getPrintDialogOptionValues = function (dialog)
            {
                var printClassDetails = dialog.content.find('.printClassOptionHeader').is(':checked');
                var showQuestionInstructions = dialog.content.find('.showQuestionInstructions').is(':checked');
                var showQuestionImages = dialog.content.find('.showQuestionImages').is(':checked');
                var leaveRoomForStudentNameCheckbox = dialog.content.find('.leaveRoomForNotes');
                var leaveRoomForStudentName = true;

                if (leaveRoomForStudentNameCheckbox.length)
                {
                    leaveRoomForStudentName = leaveRoomForStudentNameCheckbox.is(':checked')
                }

                var notStarted = dialog.content.find('.NotStarted').length == 0 || dialog.content.find('.NotStarted').is(':checked');
                var inProgress = dialog.content.find('.InProgress').length == 0 || dialog.content.find('.InProgress').is(':checked');
                var reopened = dialog.content.find('.Reopened').length == 0 || dialog.content.find('.Reopened').is(':checked');
                var reopenedAsNewAttempt = dialog.content.find('.ReopenedAsNewAttempt').length == 0 || dialog.content.find('.ReopenedAsNewAttempt').is(':checked');
                var expired = dialog.content.find('.Expired').length == 0 || dialog.content.find('.Expired').is(':checked');
                var submitted = dialog.content.find('.Submitted').length == 0 || dialog.content.find('.Submitted').is(':checked');
                var scored = dialog.content.find('.Scored').length == 0 || dialog.content.find('.Scored').is(':checked');

                var studentNameDisplayTypeCode = dialog.content.find('#StudentNameDisplayTypeCode').val();

                var dialogOptionValues =
                {
                    printClassDetails: printClassDetails,
                    showQuestionInstructions: showQuestionInstructions,
                    showQuestionImages: showQuestionImages,
                    leaveRoomForStudentName: leaveRoomForStudentName,
                    notStarted: notStarted,
                    inProgress: inProgress,
                    reopened: reopened,
                    reopenedAsNewAttempt: reopenedAsNewAttempt,
                    expired: expired,
                    submitted: submitted,
                    scored: scored,
                    studentNameDisplayTypeCode: studentNameDisplayTypeCode
                }

                return dialogOptionValues;
            }

            var studentOnlineAssignmentPrintoutPopupCreate = function (dialog) {
                var parameters = onlineStudentAssignmentPrintoutPopupParameters(dialog);
                var buildHTML = studentAssignmentPrintoutPopupBuild('BuildOnlineStudentAssignmentPrintout', parameters);

                var popupHeaderPostfix = '';

                if (parameters.isMultiPrint == 'True')
                {
                    popupHeaderPostfix = 's';
                }

                var printButton = { id: 'studentAssignmentPrintoutPopupPrint', text: "Print", click: function () { studentAssignmentAnswerKeySharedPrintoutPopupPrint('Print Student Assignment' + popupHeaderPostfix, 'BuildOnlineStudentAssignmentPrintoutPdf', parameters); }, icon: "PrintAvailable" };
                var closeButton = { id: 'studentAssignmentPrintoutPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Student Assignment' + popupHeaderPostfix, buildHTML, [printButton, closeButton], { width: "75%", additionalClasses: "studentAssignmentModal" });
                gridPopup.content.addClass('studentAssignmentPrintoutModalContent');
            };

            var studentAssignmentAnswerKeySharedPrintoutPopupPrint = function (title, action, data)
            {
                var url = skyward.global.virtualDir + "Gradebook/Assignment/" + action;
                skyward.printScreen.launchWorkflow(url, data);
                return true;
            };

            skyward.gradebookassignment.addStudentQuestionComment = function (button)
            {
                button = $(button);
                var commentID = button.data("commenttextareaid");
                var studentQuestionID = button.data("studentquestionid");
                var hasCommentID = button.data("hascommentid");
                skyward.gradebookassignment.toggleStudentQuestionComment(commentID, studentQuestionID, hasCommentID, true);
            };

            skyward.gradebookassignment.clearStudentQuestionComment = function (button)
            {
                button = $(button);
                var commentID = button.data("commenttextareaid");
                var studentQuestionID = button.data("studentquestionid");
                var hasCommentID = button.data("hascommentid");
                skyward.gradebookassignment.toggleStudentQuestionComment(commentID, studentQuestionID, hasCommentID, false);
            };

            skyward.gradebookassignment.toggleStudentQuestionComment = function (commentID, studentQuestionID, hasCommentID, show)
            {
                if (commentID == null || commentID === '' ||
                    studentQuestionID == null || studentQuestionID === '' ||
                    hasCommentID == null || hasCommentID === '')
                {
                    return;
                }

                var commentBox = $("#" + commentID);

                if (commentBox.length > 0)
                {
                    const focusDelay = 250;
                    const buttonIDPrefix = "StudentQuestionCommentButton";
                    const clearPostFix = "Clear-";
                    const addPostFix = "Add-";
                    var buttonToHideID = buttonIDPrefix + (show ? addPostFix : clearPostFix) + studentQuestionID;
                    var buttonToShowID = buttonIDPrefix + (show ? clearPostFix : addPostFix) + studentQuestionID;

                    skyward.controls.show($("#" + buttonToShowID), false);
                    skyward.controls.hide($("#" + buttonToHideID), false);
                    if (show)
                    {
                        skyward.controls.show(commentBox);
                        setTimeout(function ()
                        {
                            commentBox.focus();
                        }, focusDelay);
                    }
                    else
                    {
                        skyward.controls.setValue(commentBox, null);
                        skyward.controls.hide(commentBox);

                        var helpLabel = $("#" + commentID + "-Help");
                        if (helpLabel.length && helpLabel.children().length > 0)
                        {
                            helpLabel.children().remove();
                        }
                    }

                    var hasComment = $("#" + hasCommentID);
                    if (hasComment.length)
                    {
                        skyward.controls.setValue(hasComment, show.toString());
                    }
                }
            };

            $(selector).find('.AssignmentTemplateFilter').on('change', function (event)
            {
                var data = $(this).data();
                var parentContainerData = $(this).parents("div.assignmentTemplateFiltersContainer").first().data();

                updateTemplateFilterTeacherSetting = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/AssignmentTemplate/UpdateTemplateFilterTeacherSetting",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        selectedFilterObjectIDs: $(this).find('#' + data.hiddenBackingDataId).val(),
                        filterObject: data.filterobject,
                        controller: parentContainerData.controller
                    },
                    activityIndicator: { silent: true }
                });
            });

            var initEvents =
            {
                'printOnlineStudentAssignment': printOnlineStudentAssignment,
                'printStudentAssignment': printStudentAssignment,
                'printAnswerKey': printAnswerKey,
                'massUpdateMinutesAllowed': massUpdateMinutesAllowed,
                'clearAdditionalMinutesColumn': clearAdditionalMinutesColumn,
                'updateSingleStudentAssignmentComboBoxInit': updateSingleStudentAssignmentComboBoxInit
            };

            skyward.events.registerEvents('gradebookassignment', initEvents);
        };

        var getAllSectionIDs = function (browse)
        {
            var sectionIDs = [];

            browse.find(".browseBody").find("tr:not('.unlockedHeaderTableRow')").each(function ()
            {
                var sectionID = getRowSectionID($(this));
                sectionIDs.push(sectionID);
            });

            return JSON.stringify(sectionIDs);
        };

        var getRowSectionID = function (row)
        {
            return parseInt(row.find("input.checkbox").attr("id").split("-")[1]);
        };

        var updateOnlineAssignments = function (selector, checkbox)
        {
            var dueDateField = $(selector).find(".assignmentDetails.dueDate");
            var assignedDateField = $(selector).find(".assignmentDetails.assignedDate");
            var startTimeField = $(selector).find(".assignmentDetails.startTime");
            var startTimeTimeField = $(selector).find(".assignmentDetails.startTimeTime");
            var endTimeField = $(selector).find(".assignmentDetails.endTime");
            var endTimeTimeField = $(selector).find(".assignmentDetails.endTimeTime");

            if (checkbox.get(0).checked)
            {
                startTimeField.val(assignedDateField.val());
                startTimeTimeField.val("12:00 AM");
                endTimeField.val(dueDateField.val());
                endTimeTimeField.val("12:00 AM");
            }
            else
            {
                startTimeField.val('');
                startTimeTimeField.val('');
                endTimeField.val('');
                endTimeTimeField.val('');
            }
        };

        var updateDueDate = function (assignedDateInput, isWorkflow)
        {
            var dueDateField;
            var assignedDateValue = assignedDateInput.val();

            if (isWorkflow)
            {
                dueDateField = $("[name='Assignment.DueDate']");
            }
            else
            {
                dueDateField = $('#editAssignment_DueDate');
            }
            var dueDate = skyward.time.parseDate(dueDateField.val().split(' ')[0]);
            var assignedDate = skyward.time.parseDate(assignedDateValue.split(' ')[0]);

            if (assignedDate.isValidDate() && dueDate.isValidDate() && assignedDate > dueDate)
            {
                dueDateField[0].value = assignedDateValue;
                dueDateField.trigger('change');
            }
        };
        var updateCurrentAddedMedia = function (contentArea, scopingVariables)
        {
            var imageID = '#QuestionAnswerMediaElement';
            if (scopingVariables.length >1)
            {
                imageID += scopingVariables[1];
            }
            var image = $(imageID);

            if(image && image.length >0)
            {
                image.remove();
            }

        };

        var invalidWeightPopup = function ()
        {
            var button = $(this);
            var data = button.data();
            var content = "Assignment weights must be a whole number when calculating into a decaying average score.<br/>This assignment weight is currently rounding to the nearest whole number when calculating into a decaying average score.<br/><br/><div>The rounded weight will be <span class='boldFont'>" + data.roundedWeight + "</span></div>";
            var options =
            {
                anchorTo: button
            };

            skyward.modalLayer.showInformationDialog("Invalid Weight", content, null, options);
        };

        var initUseGradeMarkScoring = function ()
        {
            var checkbox = $(this);
            var data = checkbox.data();

            if (data && data.changeGradeMarkScoring && data.changeGradeMarkScoring != null && data.changeGradeMarkScoring != "")
            {
                skyward.controls.setValue(checkbox, data.changeGradeMarkScoring);
            }
        };

        var initCheckGradeColor = function ()
        {
            var input = $(this);
            var inputData = input.data();

            if (inputData.gradeColor != null && inputData.gradeColor != "")
            {
                input.css("border-color", inputData.gradeColor);
                input.css("border-style", "solid");
                input.css("border-width", "2px");
            }
        };

        var events =
        {
            'invalidWeight': invalidWeightPopup,
            'initUseGradeMarkScoring': initUseGradeMarkScoring,
            'initCheckGradeColor': initCheckGradeColor
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('gradebookassignment', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);